import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { apiSlice } from '../api/apiSlice';
import authReducer from './features/auth/authSlice';
import localForage from 'localforage';

localForage.config({
  driver: localForage.INDEXEDDB,
  name: `${process.env.REACT_APP_BASE_NAME}`,
  storeName: 'keyValuePairs',
  version: 1.0,
});

const persistConfig = {
    key: 'root',
    version: 1,
    storage: localForage,
    whitelist: ['auth'],  // Only persist auth and user slices
  };

const rootReducer = combineReducers({
    auth: authReducer,
    [apiSlice.reducerPath]: apiSlice.reducer, // RTK Query API slice 
});

export const persistedReducer = persistReducer(persistConfig, rootReducer);

export default rootReducer;
